// extracted by mini-css-extract-plugin
module.exports = {"svg":"assets-module--svg--14LJR"};